"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    display: 'block',
    color: palette.tFilled,
    fontFamily: palette.fontFamily,
    fontSize: palette.tsNormal,
    fontWeight: palette.twNormal,
    lineHeight: 1.5,
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: palette.gutter + 'px',
    paddingBottom: palette.gutter + 'px',
    labelColor: palette.tLabel,
    labelFontSize: palette.tsXSmall,
    labelLineHeight: palette.tlXSmall,
    errorLabelColor: palette.tError,
    width: 'auto',
    minWidth: 'auto'
  };
}